module.exports = __webpack_public_path__ + "media/images/odyssey-3cb34b31.svg";